import React, { memo, useEffect, useMemo, useState } from "react";

import Question from "./question";
import CreateNewQuestion from "./create-new-question";

import "./styles.scss";

const Questions = memo(({ form, questionsKeys: questionIdsString }) => {
	const { setFieldsValue, getFieldDecorator } = form;
	const questionsIds = useMemo(
		() => questionIdsString?.split(",").map(Number) || [0],
		[questionIdsString]
	);
	const [biggestId, setBiggestId] = useState(0);
	useEffect(() => {
		setBiggestId((biggestId) =>
			Math.max(
				biggestId,
				questionsIds.reduce((acc, questionKey) => {
					if (acc < questionKey) {
						return questionKey;
					} else {
						return acc;
					}
				}, 0)
			)
		);
	}, [questionsIds]);
	return (
		<>
			{getFieldDecorator("questionsKeys", {
				initialValue: "0",
			})(<input style={{ display: "none" }} />)}
			{questionsIds.map((questionId) => (
				<Question
					form={form}
					download
					deleteQuestion={(questionId) => {
						setFieldsValue({
							questionsKeys: questionsIds
								.filter((question) => question !== questionId)
								.join(","),
						});
					}}
					questionId={questionId}
					key={`question-${questionId}`}
				/>
			))}
			<CreateNewQuestion
				onAdd={() => {
					if (questionsIds.length === 0) {
						setFieldsValue({
							questionsKeys: "0",
						});
					} else {
						setFieldsValue({
							questionsKeys: [...questionsIds, biggestId + 1].join(","),
						});
					}
				}}
			/>
		</>
	);
});

export default Questions;
